/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import template from './report-schedules-form.component.html';
import {compareById} from '../../common/util/object-id-comparison';

@Component({
  standalone: false,
  selector: 'adn-report-schedules-form',
  template
})
export class ReportSchedulesFormComponent {
  @Input() reportSchedule: any;
  @Input() reportType: string;
  @Input() reportTemplates: any[] = [];
  @Input() lineItemReportTemplates: any[] = [];
  @Input() schedulePeriods: any[] = [];
  @Input() availableCurrencies: string[] = [];

  readonly weekDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  readonly compareById = compareById;

  @Output() editRecipients = new EventEmitter<any>();
}
